// AudioContext.js
import React, { createContext, useContext, useRef } from 'react';
import OnDemandAlert from 'assets/audios/on-demand-alert.mp3';

const OnDemandAlertContext = createContext();

export const AudioProvider = ({ children }) => {
  const audioRef = useRef(null);
  if (!audioRef.current) {
    audioRef.current = new Audio(OnDemandAlert);
  }

  const play = () => {
    audioRef.current.play().catch((error) => {
      console.warn('Unable to play on-demand alert sound:', error);
    });
  };

  const pause = () => {
    audioRef.current.pause();
  };

  const unlock = () => {
    audioRef.current
      .play()
      .then(() => {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      })
      .catch(() => {});
  };

  return (
    <OnDemandAlertContext.Provider value={{ play, pause, unlock }}>
      {children}
    </OnDemandAlertContext.Provider>
  );
};

export const useAudio = () => useContext(OnDemandAlertContext);
